import { HiX } from 'react-icons/hi'

import { Box, Flex, Icon, Text } from '@chakra-ui/react'

import { SelectChipIProps } from './types'

export const SelectChip = ({
  label,
  showIcon = true,
  onRemove,
  bgColor = '#2A5A5A',
  textColor = 'white',
}: SelectChipIProps) => {
  return (
    <Flex
      alignItems='center'
      bgColor={bgColor}
      borderRadius='4px'
      gap='6px'
      px='8px'
      py='4px'
    >
      <Text color={textColor} fontSize='14px' fontWeight='500'>
        {label}
      </Text>
      <Box
        _hover={{ opacity: 0.7 }}
        as='button'
        cursor='pointer'
        display='flex'
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation()
          e.preventDefault()
          if (showIcon) {
            onRemove()
          }
        }}
        onMouseDown={(e: React.MouseEvent) => {
          e.stopPropagation()
          e.preventDefault()
        }}
        onTouchEnd={(e: React.TouchEvent) => {
          e.stopPropagation()
          e.preventDefault()
        }}
        type='button'
      >
        {showIcon && <Icon as={HiX} boxSize='14px' color={textColor} />}
      </Box>
    </Flex>
  )
}
